<div *ngIf="show">
  <button class="pdf-btn" (click)="createPdf()" mat-button [disableRipple]="true">
    <img src="./assets/img/icon_pdf.svg" alt="icon_pdf" /> Ver cotización detallada
  </button>
</div>